import React, { useEffect, useState } from "react";
import { Table, Spinner, Button, Card, CardBody } from "reactstrap";
import { toast } from "react-toastify";
import { getGroupedDesignationsApi, deleteDesignationApi, reactivateDesignationApi } from "../../../apiServices/designation.services";

const DesignationList = ({ refresh, tab, setMode, setSelected, setModal }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await getGroupedDesignationsApi();
      setData(res?.data?.data || []);
    } catch {
      toast.error("Failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [refresh]);

  if (loading) return <Spinner />;

  return (
    <div>
      <Card>
        <CardBody>
            {data.map(dep => (
                <div key={dep.departmentId} className="mb-4">
                <h5>
                    {dep.departmentName} 
                    {/* ({dep.activeCount} / {dep.inactiveCount}) */}
                </h5>

                <Table bordered>
                    <thead>
                    <tr>
                        <th>Title</th>
                        <th>Level</th>
                        <th>Members</th>
                        <th>Active</th>
                        <th>Inactive</th>
                        <th>Action</th>
                    </tr>
                    </thead>

                    <tbody>
                    {(tab === "active"
                        ? dep.designationsActive
                        : dep.designationsInactive
                    ).map(d => (
                        <tr key={d._id}>
                        <td>{d.title}</td>
                        <td>{d.level.toUpperCase()}</td>
                        <td>{d.memberCount}</td>
                        <td>{d.activeMembers}</td>
                        <td>{d.inactiveMembers}</td>

                        <td>
                            {tab === "active" && (
                            <>
                                <Button
                                size="sm"
                                color="primary"
                                onClick={() => {
                                    setMode("edit");
                                    setSelected(d);
                                    setModal(true);
                                }}
                                >
                                Edit
                                </Button>

                                <Button
                                size="sm"
                                color="danger"
                                className="ms-2"
                                onClick={() => deleteDesignationApi(d._id).then(fetchData)}
                                >
                                Delete
                                </Button>
                            </>
                            )}

                            {tab === "inactive" && (
                            <Button
                                size="sm"
                                color="success"
                                onClick={() => reactivateDesignationApi(d._id).then(fetchData)}
                            >
                                Reactivate
                            </Button>
                            )}
                        </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
                </div>
            ))}
        </CardBody>
      </Card>
    </div>
  );
};

export default DesignationList;